module.exports = __webpack_public_path__ + "img/farmshot-logo.2ac448be.svg";